module.exports = __webpack_public_path__ + "officialStatic/img/plus-icon9.9d660c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/plus-icon9.png
// module id = u2XE
// module chunks = 0